import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:3002/api',
  baseURL : "https://portret.ai/api",
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access-token');
  if (token && config.headers) {
    config.headers['access-token'] = token;
  }
  return config;
}, (err: any) => Promise.reject(err));

api.interceptors.response.use((config) => {
  const token = config.headers['access-token'];
  // console.log(config.headers, 'headers');
  if (token) {
    localStorage.setItem('access-token', token);
  }
  return config;
}, (err: any) => Promise.reject(err));

export default {
  list_prompts() {
    return api.get('/prompts');
  },
  new_prompt(text : any) {
    return api.post('/prompts', {
      text : text.replace('coolperson', 'alexanderkozhevin')
    });
  },
  start_train() {
    return api.post('/users/set-status', {
      status: 'in_progress'
    });
  },
  avatars(page: any) {
    return api.get('/avatars?page=' + page);
  },
  photos() {
    return api.get('/users/photos');
  },
  add_photo(name: string) {
    return api.post('/photos/make_photo', { name });
  },
  check() {
    return api.get('/photos');
  },
  authenticate() {
    return api.post('/auth');
  },
  login(email: string, password: string) {
    return api.post('/auth/login', { email, password });
  },
  register(email: string, password: string) {
    return api.post('/auth/register', { email, password });
  }
}
